import { useTranslation } from "react-i18next";

import { APIFilter } from "shared/api/utils";
import { useConfigContext } from "shared/contexts/ConfigContext";

import Tooltip from "features/components/Tooltip";
import { DEFAULT_FILTER_BUILDER_STATE } from "features/ui/Filters/FilterBuilder/constants";
import {
  filterBuilderQueryToFilterBuilderState,
  getFiltersQuery,
} from "features/ui/Filters/FilterBuilder/utils";
import Link from "features/ui/Link";

import { useRepairPartsLink } from "./utils";

interface Props {
  assetFilter: string;
  repairPartsFilter: APIFilter[];
  repairPartsCount?: number;
}

const PriceAdvisorRepairPartsLink = ({
  assetFilter,
  repairPartsFilter,
  repairPartsCount = 0,
}: Props) => {
  const { t } = useTranslation("duck");
  const { pages } = useConfigContext();

  const assetFilterState = filterBuilderQueryToFilterBuilderState(assetFilter);

  const link = useRepairPartsLink(
    getFiltersQuery(undefined, repairPartsFilter),
    getFiltersQuery(assetFilterState ?? DEFAULT_FILTER_BUILDER_STATE)
  );

  if (!pages.repairParts) {
    return (
      <span className="text-xs">
        {t("recent_parts", { count: repairPartsCount })}
      </span>
    );
  }

  return (
    <Link to={link} target="_blank">
      <Tooltip title={t("parts_tooltip")}>
        <span className="text-xs">
          {t("recent_parts", { count: repairPartsCount })}
        </span>
      </Tooltip>
    </Link>
  );
};

export default PriceAdvisorRepairPartsLink;
